import { matchPath } from "react-router-dom";

//Common
import {
  BASE_NAME,
  IDENTIFICACAO_USUARIO_ADMIN,
  IDENTIFICACAO_USUARIO_SYSTEM,
  IDENTIFICACAO_USUARIO_SYSTEM_DEV,
} from "@/common/constantes";

/*
 *  A SESSÃO DO USUÁRIO POSSUI A SEGUINTE ESTRUTURA:
 *  sessaoUsuario:
 *  {
 *     token
 *     tempo_sessao
 *     path,
 *     usuario: {id, id_tenant, identificacao, nome
 *               perfil: { id, nome, acesso_tipos_solicitacao }
 *               data_ultimo_login
 *              },
 *     menus,
 *     telas
 *     areas
 * }
 */

/*
 * Retorna o path ref. ao tenant do usuário que foi gravado em cache para ser
 * utilizado na página de sessão expirada, permitindo redirecionar para a
 * página de login com o path que ele estava logado.
 */
export function fn_getPathTenantCache() {
  return localStorage.getItem("pathTenant");
}

/*
 * Retorna o path ref. ao tenant do usuário logado
 */
export function fn_getPathTenant(sessaoUsuario) {
  return sessaoUsuario ? sessaoUsuario.path : null;
}

/*
 * Retorna o token do usuário logado
 */
export function fn_getTokenUsuario(sessaoUsuario) {
  return sessaoUsuario ? sessaoUsuario.token : null;
}

/*
 * Retorna o usuario logado
 */
export function fn_getUsuario(sessaoUsuario) {
  return sessaoUsuario ? sessaoUsuario.usuario : null;
}

/*
 * Retorna a data do último login do usuário para controle da alteração da senha no primeiro acesso.
 */
export function fn_getDataUltimoLogin() {
  return sessionStorage.getItem("dataUltimoLogin");
}

/*
 * Retorna true se a identificação do usuário for SYSTEM e false se não for.
 */
export function fn_usuarioIsSystem(sessaoUsuario) {
  const identificacao = sessaoUsuario?.usuario?.identificacao;

  return identificacao == IDENTIFICACAO_USUARIO_SYSTEM ||
    identificacao == IDENTIFICACAO_USUARIO_SYSTEM_DEV
    ? true
    : false;
}

/*
 * Retorna true a identificação do usuário for ADMIN e false se não for.
 */
export function fn_usuarioIsAdmin(sessaoUsuario) {
  return sessaoUsuario?.usuario?.identificacao == IDENTIFICACAO_USUARIO_ADMIN
    ? true
    : false;
}

/*
 * Retorna um array com os menus que o usuário possui acesso.
 */
export function fn_getMenusUsuario(sessaoUsuario) {
  return sessaoUsuario?.menus ? sessaoUsuario.menus : [];
}

/*
 * Retorna um array com as telas que o usuário possui acesso.
 */
export function fn_getTelasUsuario(sessaoUsuario) {
  return sessaoUsuario?.telas ? sessaoUsuario.telas : [];
}

/*
 * Retorna o id da tela que está aberta (rota atual do navegador) ou null se a rota não for de uma tela do usuário.
 * Utilizado para informar ao servidor a tela que originou a requisição (gravada no log de alteração).
 * OBS: Janela (modal) aberta dentro de uma tela é identificada pela tela em que foi aberta.
 */
export function fn_getIdTelaAtual(sessaoUsuario, pathname) {
  let rotaAtual = String(pathname ?? window.location.pathname);

  //Retira a subpasta em que o sistema está publicado, se houver
  if (BASE_NAME && rotaAtual.startsWith(BASE_NAME)) {
    rotaAtual = rotaAtual.substring(BASE_NAME.length);
  }

  //Compara como o roteador compara: aceita a rota cadastrada com ou sem a barra inicial e rota com parâmetro
  const tela = fn_getTelasUsuario(sessaoUsuario).find(
    (item) =>
      item.rota &&
      matchPath(`/${String(item.rota).replace(/^\/+/, "")}`, rotaAtual),
  );

  return tela?.id ?? null;
}

/*
 * Retorna um array com as áreas que o usuário possui acesso.
 */
export function fn_getAreasUsuario(sessaoUsuario) {
  return sessaoUsuario?.areas ? sessaoUsuario.areas : []; //vazio significa acesso à todas áreas
}

/*
 * Retorna um array com os tipos de solicitação que o usuário possui acesso.
 */
export function fn_getTiposSolicitacaoUsuario(sessaoUsuario) {
  const perfil = sessaoUsuario?.usuario?.perfil;

  return perfil?.acesso_tipos_solicitacao
    ? perfil.acesso_tipos_solicitacao.split(",")
    : []; //vazio significa acesso à todos os tipos
}

/*
 * Retorna true se o usuário possuir acesso em determinada ação da tela e false se não possuir
 */
export function fn_isAcessoAcaoTela(sessaoUsuario, idTela, acaoTela) {
  //Para usuario system e admin o acesso é FULL dentro da tela, menos as ações inativas
  if (fn_usuarioIsSystem(sessaoUsuario) || fn_usuarioIsAdmin(sessaoUsuario)) {
    const tela = fn_getTelasUsuario(sessaoUsuario).find((t) => t.id == idTela);

    return !(tela?.acoes_inativas || []).includes(acaoTela);
  }
  //Se for usuário que tem liberação de acesso, verifica as ações liberadas
  else {
    const telas = fn_getTelasUsuario(sessaoUsuario);

    const tela = telas.find((t) => t.id == idTela);

    if (tela) {
      const acoes = tela?.acoes ? tela.acoes.split(",") : [];

      return acoes.some((acao) => acao == acaoTela);
    } else {
      return false;
    }
  }
}
